'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = FeatureArea;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _planFeaturesMap = require('./data/plan-features-map.json');

var _planFeaturesMap2 = _interopRequireDefault(_planFeaturesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function FeatureArea(p) {

    var planName = p.planName || 'Pro';
    var features = _planFeaturesMap2['default'][planName]['features'];

    var featureItems = features.map(function (feature, idx) {

        var imgSrc = require('./assets/' + feature.image);
        var img = _react2['default'].createElement('img', { className: 'feature-image', src: imgSrc });
        var text = _react2['default'].createElement(
            'p',
            { className: 'feature-text' },
            feature.text
        );

        return _react2['default'].createElement(
            'li',
            { key: 'item-' + idx },
            img,
            text
        );
    });

    var itemList = _react2['default'].createElement(
        'ul',
        null,
        featureItems
    );

    var header = _react2['default'].createElement(
        'div',
        { className: 'feature-header' },
        'Unlock access to these features'
    );
    var andmore = _react2['default'].createElement(
        'div',
        { className: 'and-more' },
        'and more'
    );

    return _react2['default'].createElement(
        'div',
        { className: 'feature-area' },
        header,
        itemList,
        andmore
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/feature-area.jsx
 ** module id = 1101
 ** module chunks = 0
 **/